import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Product } from 'src/app/models/interface/product/product';
import { Rfs } from 'src/app/models/interface/product/rfs';
import { IpService, ServiceIpInfoResponse } from 'src/app/services/api/ip/ip.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductService } from 'src/app/services/api/product/product.service';
import { Task4WorkService, TaskStatusResponse } from 'src/app/services/api/task4work/task4work.service';
import { ProductDetailService } from '../../../../product-detail.service';
import { InstallationStatusComponent } from './installation-status/installation-status.component';
import { IpListComponent } from './ip-list/ip-list.component';

@Component({
  selector: 'app-product-depth-level-rfs-actions',
  templateUrl: './product-depth-level-rfs-actions.component.html',
  styleUrls: ['./product-depth-level-rfs-actions.component.scss']
})
export class ProductDepthLevelRfsActionsComponent implements OnInit {

  @Input() item: Product;

  private serviceId: number;
  private type: string;
  specId: string;
  private taskId: string;
  private subscriptions = new Subscription();

  dialogInstallationStatusRef: MatDialogRef<InstallationStatusComponent>;

  constructor(
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private productDetailService: ProductDetailService,
    private task4WorkService: Task4WorkService,
    private ipService: IpService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private productService: ProductService
  ) { }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.queryParamMap.subscribe(params => {
      this.serviceId = +params.get('map');
      this.type = !params.get('type') ? 'product' : params.get('type');
      const rfs = this.item.cfses[0].rfses.find(rfs => rfs.id == this.serviceId);
      this.specId = rfs.specId;
      let taskIdChar = rfs.rfsCharValues.find(charValue => charValue.specId == 'sc_ftth_crm_id');
      if (taskIdChar) {
        this.taskId = taskIdChar.value;
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  installationStatus() {
    this.task4WorkService.getTaskStatus(this.taskId).subscribe(
      (data: TaskStatusResponse) => {
        this.dialog.open(InstallationStatusComponent,
          {
            data,
            restoreFocus: false,
            autoFocus: false
          })
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('INSTALLATION_STATUS.error'), NotificationLevel.ERROR);
      }
    );
  }

  ipList() {
    const remoteId = this.item.cfses[0].cfsCharValues.find(charValue => charValue.specId == "sc_network_remote_id").value;
    this.productService.getProduct(this.item.id.toString()).subscribe(
      (data: Product) => {
        this.item = data;
        this.ipService.getIpList(remoteId).subscribe(
          (data: ServiceIpInfoResponse) => {
            const matDialogRef = this.dialog.open(IpListComponent,
              {
                data: { ipInfo: data, item: this.item },
                minWidth: "50%",
                height: "100%",
                restoreFocus: false,
                autoFocus: false,
                disableClose: true
              })
            matDialogRef.afterClosed().subscribe((item: Product) => {
              this.item = item;
            });
          },
          (error) => {
            this.notificationsService.showNotification(this.translateService.instant('IP_LIST.list_error'), NotificationLevel.ERROR);
          }
        );
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('PRODUCTS_KEY.infoError'), NotificationLevel.ERROR);
      }
    );
  }

}
